import colors from '../colors.js';
var a = colors("66c2a5fc8d628da0cbe78ac3a6d854ffd92fe5c494b3b3b3");
export { a as default };
//# sourceMappingURL=Set2.js.map
